import { Component } from 'react';
import { has } from 'ramda';
import firebase from 'firebase';
import 'firebase/auth';

class LoginContainer extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            error: null,
            loading: false,
            email: '',
        }
    }
    
    onSubmit = event => {
        event.preventDefault();

        const { history } = this.props;
     
        this.setState({
            error: null,
            loading: true,
        });

        firebase.auth().signInWithEmailAndPassword(this.state.email, '123456')
            .then(user => {
                if (user && has('user', user)) {
                    history.push('/dashboard/start', { fromLogin: true })
                    
                    this.setState({
                        loading: false,
                    });
                }
            })
            .catch(message => {
                this.setState({
                    error: message,
                    loading: false,
                });
            });
    }

    handleEmailChange = event => this.setState({ email: event.target.value });

    redirectToRegistration = event => {
        event.preventDefault();
        this.props.history.push('/register');
    }

    render() {
        const { email, loading, error } = this.state;

        return this.props.render({
            email,
            loading,
            error,
            onSubmit: this.onSubmit,
            handleEmailChange: this.handleEmailChange,
            redirectToRegistration: this.redirectToRegistration,
        })
    }
}

export default LoginContainer;
